import React from 'react';
import PropTypes from 'prop-types';

const AdditionalSignUpFieldsOption = () => {
  const { value } = this.props;
  // NOTE: just handling one case for now is enough
  const { icon, name, options, placeholder, type, validator } = value[0];

  const typeRow = type === 'select' && (
    <li className="line-row">
      <span>
          type: "select"
        </span>
    </li>
  );

  const validatorRow = validator && (
    <li className="line-row">
      <span>
          validator: {validator.toString()}
      </span>
    </li>
  );

  const optionsRow = options && (
    <div className="line-row">
      <li className="line-row">
        <span>
            options: {'{'}
        </span>
      </li>
      <div className="line-row">
        {options.map(x => (
          <li className="line-row">
            <span>
              {'{'}label: "{x.label}", value: "{x.value}"{'}'}
            </span>
          </li>
            ))}
      </div>
      <li className="line-row">
        <span>
          {'}'}
        </span>
      </li>
    </div>
  );

  return (
    <div className="line-row">
      <li className="line-row">
        <span>
          additionalSignUpFields: [{'{'}
        </span>
      </li>
      <li className="line-row">
        <span>
          name: "{name}"
        </span>
      </li>
      {typeRow}
      <li className="line-row">
        <span>
          placeholder: "{placeholder}"
        </span>
      </li>
      <li className="line-row">
        <span>
          icon: "{icon}"
        </span>
      </li>
      {optionsRow}
      {validatorRow}
      <li className="line-row">
        <span>
          {'}'}]
        </span>
      </li>
    </div>
  );
};

AdditionalSignUpFieldsOption.propTypes = {
  value: PropTypes.array.isRequired
};

export default AdditionalSignUpFieldsOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/AdditionalSignUpFieldsOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/AdditionalSignUpFieldsOption.js